import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import YildizArkaplan from "../components/YildizArkaplan";
import { FALCILAR } from "../data/falcilar";
import { useToken } from "../context/TokenContext";
import { useFal } from "../context/FalContext";
import { useTranslation } from "react-i18next";
import { supabase } from "../supabaseClient";
import { isNativeApp, showFalHemenOkuAd } from "../utils/nativeBridge";

const FAL_TURLERI = {
  kahve: { isimKey: "readings.coffee", emoji: "☕", aciklamaKey: "falYorum.photoSection", cokluFoto: true, dogumTarihi: false, fotograflar: [] },
  el: { isimKey: "readings.hand", emoji: "✋", cokluFoto: false, dogumTarihi: true, fotograflar: [{ id: "el", labelKey: "readings.hand", icon: "✋" }] },
  yuz: { isimKey: "readings.face", emoji: "👤", cokluFoto: false, dogumTarihi: true, fotograflar: [{ id: "yuz", labelKey: "readings.face", icon: "👤" }] },
  iliski: { isimKey: "readings.relationship", emoji: "💑", cokluFoto: false, dogumTarihi: false, fotograflar: [{ id: "kisi1", labelKey: "falYorum.person1", icon: "🧍" }, { id: "kisi2", labelKey: "falYorum.person2", icon: "🧍" }] },
};

const BURCLAR = [
  { isim: "Koç", baslangic: [3, 21], bitis: [4, 19], sembol: "♈" },
  { isim: "Boğa", baslangic: [4, 20], bitis: [5, 20], sembol: "♉" },
  { isim: "İkizler", baslangic: [5, 21], bitis: [6, 20], sembol: "♊" },
  { isim: "Yengeç", baslangic: [6, 21], bitis: [7, 22], sembol: "♋" },
  { isim: "Aslan", baslangic: [7, 23], bitis: [8, 22], sembol: "♌" },
  { isim: "Başak", baslangic: [8, 23], bitis: [9, 22], sembol: "♍" },
  { isim: "Terazi", baslangic: [9, 23], bitis: [10, 22], sembol: "♎" },
  { isim: "Akrep", baslangic: [10, 23], bitis: [11, 21], sembol: "♏" },
  { isim: "Yay", baslangic: [11, 22], bitis: [12, 21], sembol: "♐" },
  { isim: "Oğlak", baslangic: [12, 22], bitis: [1, 19], sembol: "♑" },
  { isim: "Kova", baslangic: [1, 20], bitis: [2, 18], sembol: "♒" },
  { isim: "Balık", baslangic: [2, 19], bitis: [3, 20], sembol: "♓" },
];


const burcHesapla = (tarih) => {
  if (!tarih) return null;
  const [, ay, gun] = tarih.split("-").map(Number);
  for (const burc of BURCLAR) {
    const [basAy, basGun] = burc.baslangic;
    const [bitAy, bitGun] = burc.bitis;
    if ((ay === basAy && gun >= basGun) || (ay === bitAy && gun <= bitGun)) return burc;
  }
  return BURCLAR[11];
};

const beklemeSuresiHesapla = () => 10 * 60;

const fileToBase64 = (file) => new Promise((resolve) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    const orijinal = e.target.result;
    const img = new Image();
    img.onload = () => {
      const MAX = 1568;
      let w = img.naturalWidth, h = img.naturalHeight;
      if (w > MAX || h > MAX) { const o = Math.min(MAX / w, MAX / h); w = Math.round(w * o); h = Math.round(h * o); }
      const c = document.createElement('canvas');
      c.width = w; c.height = h;
      c.getContext('2d').drawImage(img, 0, 0, w, h);
      resolve({ base64: c.toDataURL('image/jpeg', 0.85), name: file.name, type: 'image/jpeg' });
    };
    img.onerror = () => resolve({ base64: orijinal, name: file.name, type: file.type });
    img.src = orijinal;
  };
  reader.readAsDataURL(file);
});

function FotoYukleme({ label, icon, onChange, preview }) {
  const { t } = useTranslation();

  if (preview) {
    return (
      <div style={{
        borderRadius: 14, border: "1px solid rgba(168,85,247,0.4)",
        background: "rgba(168,85,247,0.1)", overflow: "hidden",
        position: "relative", minHeight: 120,
      }}>
        <img src={preview} alt="yüklendi" style={{ width: "100%", maxHeight: 200, objectFit: "cover", display: "block" }} />
        <div
          onClick={() => document.getElementById(`input-foto-${label}`).click()}
          style={{
            position: "absolute", bottom: 8, right: 8,
            background: "rgba(0,0,0,0.6)", borderRadius: 20,
            padding: "3px 10px", fontSize: 11, color: "#A855F7", fontWeight: 600, cursor: "pointer",
          }}
        >
          {t("falYorum.uploaded")}
        </div>
        <input id={`input-foto-${label}`} type="file" accept="image/*" style={{ display: "none" }} onChange={onChange} />
      </div>
    );
  }

  return (
    <div style={{
      borderRadius: 14, border: "2px dashed rgba(255,255,255,0.15)",
      background: "rgba(255,255,255,0.03)", padding: "16px",
      textAlign: "center", minHeight: 120,
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12,
    }}>
      <div style={{ fontSize: 32 }}>{icon}</div>
      <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", fontWeight: 600 }}>{label}</div>
      <button
        type="button"
        onClick={() => document.getElementById(`input-foto-${label}`).click()}
        style={{
          width: "100%", padding: "10px 0", borderRadius: 10, border: "1px solid rgba(168,85,247,0.4)",
          background: "rgba(168,85,247,0.15)", color: "#C084FC", fontSize: 13, fontWeight: 600, cursor: "pointer",
        }}
      >
        📷 Fotoğraf Ekle
      </button>
      <input
        id={`input-foto-${label}`}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={onChange}
      />
    </div>
  );
}

export default function FalYorum() {
  const { falciId, falTuru } = useParams();
  const navigate = useNavigate();
  const { tokenBalance, user } = useToken();
  const { falGonder } = useFal();
  const { t } = useTranslation();

  const falci = FALCILAR.find((f) => f.id === falciId);
  const falBilgi = FAL_TURLERI[falTuru];
  const SS_KEY = 'remil_fal_photos_' + falciId + '_' + falTuru;

  const [mesaj, setMesaj] = useState("");
  const [falSahibiAdi, setFalSahibiAdi] = useState("");
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState("");
  const [fotograflar, setFotograflar] = useState(() => {
    try {
      const saved = sessionStorage.getItem(SS_KEY + '_tekli');
      return saved ? JSON.parse(saved) : {};
    } catch { return {}; }
  });
  const [cokluFotolar, setCokluFotolar] = useState(() => {
    try {
      const saved = sessionStorage.getItem(SS_KEY + '_coklu');
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });
  const [gonderildi, setGonderildi] = useState(false);
  const [beklemeDakika, setBeklemeDakika] = useState(0);
  const [hemenOkuYukleniyor, setHemenOkuYukleniyor] = useState(false);
  const [hemenOkuTamamlandi, setHemenOkuTamamlandi] = useState(false);
  const [dogumTarihi, setDogumTarihi] = useState("");
  const [dogumSaati, setDogumSaati] = useState("");
  const [dogumYeri, setDogumYeri] = useState("");

  useEffect(() => {
    try { sessionStorage.setItem(SS_KEY + '_tekli', JSON.stringify(fotograflar)); } catch {}
  }, [fotograflar]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    try { sessionStorage.setItem(SS_KEY + '_coklu', JSON.stringify(cokluFotolar)); } catch {}
  }, [cokluFotolar]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!falci || !falBilgi) return (
    <div style={{ color: "#fff", padding: 40, textAlign: "center" }}>Sayfa bulunamadı.</div>
  );

  const burc = burcHesapla(dogumTarihi);

  const fotografEkle = async (id, file) => {
    if (!file) return;
    const data = await fileToBase64(file);
    const yeni = { ...fotograflar, [id]: { preview: data.base64, base64: data.base64.split(",")[1], type: data.type } };
    try { sessionStorage.setItem(SS_KEY + '_tekli', JSON.stringify(yeni)); } catch {}
    setFotograflar(yeni);
  };

  const cokluFotoEkle = async (file) => {
    if (!file || cokluFotolar.length >= 4) return;
    const data = await fileToBase64(file);
    const yeni = [...cokluFotolar, { id: Date.now(), preview: data.base64, base64: data.base64.split(",")[1], type: data.type }];
    try { sessionStorage.setItem(SS_KEY + '_coklu', JSON.stringify(yeni)); } catch {}
    setCokluFotolar(yeni);
  };

  const cokluFotoSil = (id) => setCokluFotolar((prev) => prev.filter((f) => f.id !== id));

  const falBak = async () => {
    if (!mesaj.trim()) return;
    if (falBilgi.cokluFoto && cokluFotolar.length === 0) {
      setHata(t("falYorum.noPhoto"));
      return;
    }
    if (tokenBalance < falci.token) {
      setHata(t("falYorum.insufficientToken", { token: falci.token }));
      return;
    }

    setYukleniyor(true);
    setHata("");

    try {
      const sure = beklemeSuresiHesapla(falci.token);
      setBeklemeDakika(Math.floor(sure / 60));

      const sonuc = await falGonder({
        falciId: falci.id, falTuru, tokenMiktar: falci.token,
        fotograflar: falBilgi.cokluFoto
          ? cokluFotolar.map(f => ({ base64: f.base64, type: f.type }))
          : Object.values(fotograflar).map(f => ({ base64: f.base64, type: f.type })),
        dogumTarihi, dogumSaati, dogumYeri,
        ekNot: mesaj,
        ad: falSahibiAdi,
        burc: burc?.isim || '',
        soru: mesaj,
      });

      if (sonuc.success) {
        sessionStorage.removeItem(SS_KEY + '_tekli');
        sessionStorage.removeItem(SS_KEY + '_coklu');
        setGonderildi(true);
      } else {
        setHata(sonuc.error || t("falYorum.sendError"));
      }
    } catch (err) {
      console.error(err);
      setHata(t("falYorum.connectionError"));
    } finally {
      setYukleniyor(false);
    }
  };

  const hemenOku = () => {
    if (!isNativeApp()) return;
    setHemenOkuYukleniyor(true);
    window.onFalHemenOkuCompleted = async () => {
      window.onFalHemenOkuCompleted = null;
      window.onFalHemenOkuFailed = null;
      setHemenOkuYukleniyor(false);
      setHemenOkuTamamlandi(true);
      // Bekleme süresini 3 dakikaya düşür
      await supabase.from('fallar')
        .update({ hazir_olma_zamani: new Date(Date.now() + 3 * 60 * 1000).toISOString() })
        .eq('user_id', user?.id)
        .eq('durum', 'bekliyor')
        .order('created_at', { ascending: false })
        .limit(1);
    };
    window.onFalHemenOkuFailed = () => {
      window.onFalHemenOkuCompleted = null;
      window.onFalHemenOkuFailed = null;
      setHemenOkuYukleniyor(false);
    };
    showFalHemenOkuAd();
  };

  if (gonderildi) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
        position: "relative", fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
        maxWidth: 420, margin: "0 auto", display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
      }}>
        <style>{`* { box-sizing: border-box; margin: 0; padding: 0; }`}</style>
        <YildizArkaplan />
        <div style={{ position: "relative", zIndex: 1, padding: "40px 24px", textAlign: "center" }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>🔮</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: "#fff", fontFamily: "Georgia, serif", marginBottom: 10 }}>
            {t("falYorum.sent")}
          </div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.55)", lineHeight: 1.7, marginBottom: 8 }}>
            <span style={{ color: falci.parlak, fontWeight: 700 }}>{falci.isim}</span> {t("falYorum.sentDesc")}<br />
            {t("falYorum.sentReady", { min: beklemeDakika })}
          </div>
          <div style={{
            background: "rgba(168,85,247,0.08)", border: "1px solid rgba(168,85,247,0.2)",
            borderRadius: 14, padding: "10px 14px", marginBottom: 24,
            fontSize: 12, color: "rgba(255,255,255,0.6)",
          }}>
            {t("falYorum.notifNote")}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {!hemenOkuTamamlandi && isNativeApp() && (
              <button onClick={hemenOku} disabled={hemenOkuYukleniyor}
                style={{
                  width: "100%", padding: "14px", borderRadius: 14,
                  background: hemenOkuYukleniyor ? "rgba(255,255,255,0.05)" : "linear-gradient(135deg, #f59e0b, #fbbf24)",
                  border: "none", color: hemenOkuYukleniyor ? "rgba(255,255,255,0.3)" : "#000",
                  fontSize: 14, fontWeight: 700, cursor: hemenOkuYukleniyor ? "default" : "pointer",
                  marginBottom: 10,
                }}>
                {hemenOkuYukleniyor ? "⏳ Reklam yükleniyor..." : "▶ Reklam İzle — Hemen Oku"}
              </button>
            )}
            {hemenOkuTamamlandi && (
              <div style={{ textAlign: "center", padding: "10px", fontSize: 13, color: "#4ADE80", marginBottom: 10 }}>
                ✅ Falın 3 dakika içinde hazır olacak!
              </div>
            )}
            <button onClick={() => navigate("/fallarim")} style={{
              width: "100%", padding: "14px", borderRadius: 14,
              background: `linear-gradient(135deg, ${falci.renk} 0%, ${falci.parlak}99 100%)`,
              border: "none", color: "#fff", fontSize: 14, fontWeight: 700,
              cursor: "pointer", fontFamily: "Georgia, serif",
            }}>
              {t("falYorum.viewReadings")}
            </button>
            <button onClick={() => navigate("/")} style={{
              width: "100%", padding: "12px", borderRadius: 14,
              background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.08)",
              color: "rgba(255,255,255,0.5)", fontSize: 13, cursor: "pointer",
            }}>
              {t("falYorum.goHome")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative", fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420, margin: "0 auto", overflowY: "auto",
    }}>
      <style>{`
        @keyframes kart-gir { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes yuklenme { 0%, 100% { opacity: 0.3; transform: scale(0.8); } 50% { opacity: 1; transform: scale(1.2); } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
        textarea:focus, input:focus { outline: none; }
      `}</style>

      <YildizArkaplan />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 120 }}>

        <div style={{ padding: "52px 24px 0" }}>
          <button onClick={() => navigate(-1)} style={{
            background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: 12, padding: "8px 16px", color: "rgba(255,255,255,0.7)", fontSize: 13, cursor: "pointer",
          }}>{t("falYorum.back")}</button>
        </div>

        <div style={{
          margin: "20px 24px 0", borderRadius: 16,
          background: `${falci.renk}33`, border: `1px solid ${falci.parlak}33`,
          padding: "14px 16px", display: "flex", alignItems: "center", gap: 12,
        }}>
          <div style={{ fontSize: 32 }}>{falci.emoji}</div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#fff", fontFamily: "Georgia, serif" }}>{falci.isim}</div>
            <div style={{ fontSize: 12, color: falci.parlak }}>{falBilgi.emoji} {t(falBilgi.isimKey)}</div>
          </div>
          <div style={{ marginLeft: "auto", display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
            <div style={{
              background: "rgba(249,203,66,0.15)", border: "1px solid rgba(249,203,66,0.3)",
              borderRadius: 20, padding: "4px 12px", fontSize: 12, color: "#F9CB42", fontWeight: 700,
            }}>🪙 {falci.token}</div>
            <div style={{ fontSize: 10, color: "rgba(255,255,255,0.35)" }}>
              {t("falYorum.waitTime", { min: beklemeSuresiHesapla(falci.token) / 60 })}
            </div>
          </div>
        </div>

        {tokenBalance < falci.token && (
          <div onClick={() => navigate("/token-kazan")} style={{
            margin: "16px 24px 0", padding: "14px 16px", borderRadius: 14,
            background: "rgba(239,68,68,0.15)", border: "1px solid rgba(239,68,68,0.3)",
            color: "#FCA5A5", fontSize: 13, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "space-between",
          }}>
            <span>⚠️ {t("falYorum.insufficientTokenShort", { balance: tokenBalance })}</span>
            <span style={{ color: "#F472B6", fontWeight: 700 }}>{t("falYorum.buyToken")}</span>
          </div>
        )}

        {/* Kahve falı — çoklu fotoğraf */}
        {falBilgi.cokluFoto && (
          <div style={{ padding: "20px 24px 0" }}>
            <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 4 }}>
              {t("falYorum.photoSection")}
            </div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginBottom: 12 }}>
              {t("falYorum.photoHint")}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
              {cokluFotolar.map((foto) => (
                <div key={foto.id} style={{ position: "relative", borderRadius: 12, overflow: "hidden", border: "1px solid rgba(168,85,247,0.4)" }}>
                  <img src={foto.preview} alt="" style={{ width: "100%", height: 110, objectFit: "cover", display: "block" }} />
                  <button onClick={() => cokluFotoSil(foto.id)} style={{
                    position: "absolute", top: 6, right: 6, width: 24, height: 24,
                    borderRadius: "50%", background: "rgba(0,0,0,0.7)", border: "none",
                    color: "#fff", fontSize: 12, cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>✕</button>
                </div>
              ))}
              {cokluFotolar.length < 4 && (
                <div onClick={() => document.getElementById("coklu-foto-ekle").click()} style={{
                  borderRadius: 12, border: "2px dashed rgba(255,255,255,0.15)",
                  background: "rgba(255,255,255,0.03)", minHeight: 110,
                  display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                  cursor: "pointer", gap: 6,
                }}>
                  <div style={{ fontSize: 28 }}>{/android/i.test(navigator.userAgent) ? "📁" : "📷"}</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>{/android/i.test(navigator.userAgent) ? "Galeriden Seç" : "Fotoğraf Ekle"}</div>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.25)" }}>{cokluFotolar.length}/4</div>
                </div>
              )}
            </div>
            <input
              id="coklu-foto-ekle"
              type="file"
              accept="image/*"
              multiple
              style={{ display: "none" }}
              onChange={(e) => {
                Array.from(e.target.files || []).forEach(file => cokluFotoEkle(file));
                e.target.value = "";
              }}
            />
          </div>
        )}

        {/* El, Yüz, İlişki — tekli fotoğraf */}
        {!falBilgi.cokluFoto && falBilgi.fotograflar.length > 0 && (
          <div style={{ padding: "20px 24px 0" }}>
            <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>
              {t("falYorum.photoUpload")}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: falBilgi.fotograflar.length > 1 ? "1fr 1fr" : "1fr", gap: 12 }}>
              {falBilgi.fotograflar.map((alan) => (
                <FotoYukleme
                  key={alan.id}
                  label={t(alan.labelKey)}
                  icon={alan.icon}
                  preview={fotograflar[alan.id]?.preview}
                  onChange={(e) => fotografEkle(alan.id, e.target.files[0])}
                />
              ))}
            </div>
          </div>
        )}

        {/* Doğum bilgileri */}
        {falBilgi.dogumTarihi && (
          <div style={{ padding: "20px 24px 0" }}>
            <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 4 }}>
              {t("falYorum.birthInfo")}
            </div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginBottom: 12 }}>
              {t("falYorum.birthHint")}
            </div>
            {burc && (
              <div style={{
                background: "rgba(168,85,247,0.1)", border: "1px solid rgba(168,85,247,0.3)",
                borderRadius: 12, padding: "10px 14px", marginBottom: 12,
                display: "flex", alignItems: "center", gap: 10,
              }}>
                <div style={{ fontSize: 24 }}>{burc.sembol}</div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#C084FC" }}>{burc.isim}</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>{t("falYorum.zodiacSub")}</div>
                </div>
              </div>
            )}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <div>
                <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginBottom: 6 }}>{t("falYorum.birthDate")}</div>
                <input type="date" value={dogumTarihi} onChange={(e) => setDogumTarihi(e.target.value)}
                  style={{ width: "100%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 12, padding: "12px 14px", color: "#fff", fontSize: 14, fontFamily: "'Trebuchet MS', sans-serif", colorScheme: "dark" }} />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginBottom: 6 }}>{t("falYorum.birthTime")}</div>
                  <input type="time" value={dogumSaati} onChange={(e) => setDogumSaati(e.target.value)}
                    style={{ width: "100%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 12, padding: "12px 14px", color: "#fff", fontSize: 14, fontFamily: "'Trebuchet MS', sans-serif", colorScheme: "dark" }} />
                </div>
                <div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginBottom: 6 }}>{t("falYorum.birthPlace")}</div>
                  <input type="text" value={dogumYeri} onChange={(e) => setDogumYeri(e.target.value)} placeholder={t("falYorum.birthPlacePlaceholder")}
                    style={{ width: "100%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 12, padding: "12px 14px", color: "#fff", fontSize: 14, fontFamily: "'Trebuchet MS', sans-serif" }} />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Ad alanı */}
        <div style={{ padding: "20px 24px 0" }}>
          <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 6 }}>
            {t("falYorum.nameSection")}
          </div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginBottom: 10 }}>
            {t("falYorum.nameHint")}
          </div>
          <input type="text" value={falSahibiAdi} onChange={(e) => setFalSahibiAdi(e.target.value)}
            placeholder={t("falYorum.namePlaceholder")}
            style={{ width: "100%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 12, padding: "12px 14px", color: "#fff", fontSize: 14, fontFamily: "'Trebuchet MS', sans-serif" }} />
        </div>


        {/* Not alanı */}
        <div style={{ padding: "20px 24px 0" }}>
          <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 10 }}>
            {t("falYorum.noteSection")}
          </div>
          <textarea value={mesaj} onChange={(e) => setMesaj(e.target.value)}
            placeholder={`${falci.isim}...`} rows={4}
            style={{ width: "100%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 14, padding: "14px 16px", color: "#fff", fontSize: 14, lineHeight: 1.6, resize: "none", fontFamily: "'Trebuchet MS', Tahoma, sans-serif" }} />
        </div>

        {/* Gönder butonu */}
        <div style={{ padding: "16px 24px 0" }}>
          <button onClick={falBak} disabled={yukleniyor || !mesaj.trim() || tokenBalance < falci.token}
            style={{
              width: "100%", padding: "16px", borderRadius: 16,
              background: !mesaj.trim() || tokenBalance < falci.token ? "rgba(255,255,255,0.08)" : `linear-gradient(135deg, ${falci.renk} 0%, ${falci.parlak}99 100%)`,
              border: "none",
              color: !mesaj.trim() || tokenBalance < falci.token ? "rgba(255,255,255,0.3)" : "#fff",
              fontSize: 16, fontWeight: 700,
              cursor: !mesaj.trim() || tokenBalance < falci.token ? "default" : "pointer",
              fontFamily: "Georgia, serif", transition: "all 0.2s",
            }}>
            {yukleniyor ? t("falYorum.checking") : `${falci.emoji} ${t("falYorum.sendBtn", { token: falci.token })}`}
          </button>
        </div>

        {/* Yüklenme animasyonu */}
        {yukleniyor && (
          <div style={{ padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
            <div style={{ display: "flex", gap: 8 }}>
              {["🔮", "✨", "🌙"].map((e, i) => (
                <div key={i} style={{ fontSize: 24, animation: "yuklenme 1.2s ease-in-out infinite", animationDelay: `${i * 0.2}s` }}>{e}</div>
              ))}
            </div>
            <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", fontStyle: "italic" }}>{t("falYorum.preparing")}</div>
          </div>
        )}

        {/* Hata */}
        {hata && (
          <div style={{ margin: "16px 24px 0", padding: "14px 16px", borderRadius: 14, background: "rgba(239,68,68,0.15)", border: "1px solid rgba(239,68,68,0.3)", color: "#FCA5A5", fontSize: 13 }}>
            ⚠️ {hata}
          </div>
        )}
      </div>
    </div>
  );
}